import * as React from "react";

interface SpinnerProps {
  variant?: "small";
  /** default var(--primary-color) */
  color?: "currentColor";
}

import styles from "./index.module.css";

function Spinner(props: SpinnerProps) {
  function css() {
    return (
      (props.variant ? " " + styles[props.variant] : "") +
      (props.color === "currentColor" ? " " + styles[props.color] : "")
    );
  }

  return (
    <span
      aria-label="Loading"
      className={`${styles.spinner}${css()}`}
      aria-hidden
    />
  );
}

export default Spinner;
